import Card from "@mui/material/Card";
import React, { useState, useEffect } from "react";
import axios from "axios";
import { baseurl } from "domain";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";
import { TextField, Button, Grid, CircularProgress } from "@mui/material";
import { useNavigate } from "react-router-dom";
import authorsTableData from "layouts/managePressConfHall/data/authorsTableData";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { format } from "date-fns";

function Tables() {
  const navigate = useNavigate();
  const today = new Date();

  const [filters, setFilters] = useState({
    name: "",
    date: format(today, "yyyy-MM-dd"),
    phnNo: "",
    email: "",
    insName: "",
    bookedBy: "",
    subCatType: "",
    payment_id: "",
  });

  const [tableData, setTableData] = useState({ columns: [], rows: [] });
  const [loading, setLoading] = useState(false); // ✅ new loading state

  const handleClickView = (payment_id) => {
    navigate(`/viewPCHBooking?payment_id=${payment_id}`);
  };

  const handleClickDelete = async (spid) => {
    if (confirm("Do you really want to delete this Special Day ?")) {
      try {
        const response = await axios.delete(`https://${baseurl}/deleteSpecialDay?spid=${spid}`);
        if (response.status === 200) {
          alert("Special Day Deleted Successfully!");
          setTableData((prevData) => ({
            ...prevData,
            rows: prevData.rows.filter((row) => row.spid !== spid),
          }));
        } else {
          alert("Try Again");
        }
      } catch (error) {
        alert("Error Deleting User");
        console.error("Error deleting user:", error);
      }
    }
  };

  const handleEditClick = (payment_id) => {
    navigate(`/editPCHBooking?payment_id=${payment_id}`);
  };

  // Fetch table data
  const fetchTableData = async () => {
    const result = await authorsTableData(
      filters,
      handleClickView,
      handleClickDelete,
      handleEditClick,
      setLoading // ✅ pass setLoading to show spinner
    );
    setTableData(result);
  };

  useEffect(() => {
    fetchTableData();
  }, [filters]);

  useEffect(() => {
    const token = localStorage.getItem("authToken");
    if (!token) {
      navigate("/authentication/sign-in");
    }
  }, [navigate]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFilters((prevFilters) => ({
      ...prevFilters,
      [name]: value,
    }));
  };

  const handleClearFilters = () => {
    setFilters({
      name: "",
      date: "",
      phnNo: "",
      email: "",
      insName: "",
      bookedBy: "",
      subCatType: "",
      payment_id: "",
    });
  };

  const handleClick = () => {
    navigate("/addPCHBooking");
  };

  const handleDownload = async (filters) => {
    try {
      const response = await axios.post(`https://${baseurl}/filterPCHBookings`, filters);
      const data = response.data.pch_bookings;

      if (!data || data.length === 0) {
        alert("No data available to download.");
        return;
      }

      const formattedData = data.map((user) => ({
        Date: user.date,
        "Start Time": user.start_time,
        "End Time": user.end_time,
        Duration: user.duration,
        Status: user.status,
        Name: user.name,
        Email: user.email,
        Contact: user.contact,
        "Service ID": user.serviceId,
        "Service Name": user.serviceName,
        "Phone Number": user.phnNo,
        Amount: Number(user.amount) / 100,
        Method: user.method,
        "Payment ID": user.payment_id,
        "Order ID": user.order_id,
        "Institution Name": user.insName,
        "Sub Category Type": user.subCatType,
        "Booked By": user.bookedBy,
        "GST Number": user.gstNo,
        "Government ID": user.govId,
        Subject: user.subject,
      }));

      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.json_to_sheet(formattedData);
      XLSX.utils.book_append_sheet(workbook, worksheet, "Bookings");

      const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
      const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
      saveAs(blob, "PCH_Bookings.xlsx");
    } catch (error) {
      console.error("Error downloading Excel:", error);
      alert("Failed to download data.");
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <Grid container spacing={2} alignItems="center" justifyContent="space-between">
                  <Grid item>
                    <MDTypography variant="h6" color="white">
                      Manage Press Conference Hall Bookings
                    </MDTypography>
                  </Grid>
                  <Grid item>
                    <Button
                      variant="contained"
                      color="white"
                      onClick={handleClick}
                      style={{ backgroundColor: "white", color: "#0076CE" }}
                    >
                      + Add Bookings
                    </Button>
                  </Grid>
                </Grid>
              </MDBox>

              {/* Filters */}
              <Grid container spacing={2} padding={3} alignItems="center">
                <Grid item xs={"auto"} sm={"auto"}>
                  <TextField
                    fullWidth
                    name="date"
                    type="date"
                    value={filters.date}
                    onChange={handleChange}
                    label="Date"
                    InputLabelProps={{ shrink: true }}
                    style={{ height: 40 }}
                  />
                </Grid>
                {[
                  { name: "name", label: "Name" },
                  { name: "phnNo", label: "Phone No." },
                  { name: "email", label: "Email" },
                  { name: "insName", label: "Organization Name" },
                  { name: "bookedBy", label: "Method" },
                  { name: "subCatType", label: "Type" },
                  { name: "payment_id", label: "Payment ID" },
                ].map(({ name, label }) => (
                  <Grid item xs={"auto"} sm={"auto"} key={name}>
                    <TextField
                      fullWidth
                      name={name}
                      value={filters[name]}
                      onChange={handleChange}
                      label={label}
                      style={{ height: 40 }}
                    />
                  </Grid>
                ))}

                <Grid item xs={12} sm={2}>
                  <Button
                    fullWidth
                    variant="contained"
                    color="secondary"
                    onClick={handleClearFilters}
                    style={{ color: "white" }}
                  >
                    Clear
                  </Button>
                </Grid>

                <Grid item sm={2}>
                  <Button
                    fullWidth
                    variant="contained"
                    color="primary"
                    onClick={() => handleDownload(filters)}
                    style={{ color: "white" }}
                  >
                    Download
                  </Button>
                </Grid>
              </Grid>

              {/* Loading or DataTable */}
              <MDBox mx={2} pt={3}>
                {loading ? (
                  <MDBox display="flex" justifyContent="center" py={5}>
                    <CircularProgress color="primary" />
                  </MDBox>
                ) : (
                  <>
                    <DataTable
                      table={{
                        columns: tableData.columns,
                        rows: tableData.rows.length > 0 ? tableData.rows : [],
                      }}
                      isSorted={false}
                      entriesPerPage={false}
                      showTotalEntries={false}
                    />
                    {tableData.rows.length === 0 && (
                      <MDBox display="flex" justifyContent="center" pb={3}>
                        <MDTypography variant="h5" color="text">
                          No data for selected filter
                        </MDTypography>
                      </MDBox>
                    )}
                  </>
                )}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Tables;
